var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import produce from 'immer';
export var getInitialState = function () { return ({
    resellers: [],
    normal_organizations: [],
    resellers_loading: false,
    resellers_error: false,
    normal_orgs_loading: false,
    normal_orgs_error: false,
    normal_orgs_initialized: false,
    reseller_add_loading: false,
    reseller_add_error: false,
    reseller_remove_loading: false,
    resellers_remove_error: false,
    selected_reseller_details: {
        reseller_details: {
            author: '',
            company_name: '',
            company_number: '',
            confirmed: false,
            contact_email: '',
            contact_number: '',
            contact_person: '',
            created_at: '',
            currency: '',
            default_payment_method: '',
            description: '',
            dev_plan: '',
            dev_plan_subscription: '',
            id: '',
            managed_org_count: 0,
            meta: { reseller_number: '' },
            name: '',
            paid_until: '',
            partner: false,
            public_bundle_access: false,
            stripe_customer_default_payment_method: '',
            type: '',
            updated_at: '',
        },
        invoice_summery: {
            id: '',
            billing_date: '',
            total_amount: {
                reseller_amount: 0,
                managed_orgs_amount: 0,
                total: 0,
            },
            invoice_status: '',
        },
        managed_organizations: [],
        reseller_details_loading: false,
        reseller_details_error: false,
        invoice_summery_loading: false,
        invoice_summery_error: false,
        managed_organizations_loading: false,
        managed_organizations_error: false,
        add_managed_organization_loading: false,
        add_managed_organization_error: false,
        remove_managed_organization_loading: false,
        remove_managed_organization_error: false,
        selected_managed_org_dev_plans: [],
        selected_managed_org_dev_plans_interval: 'year',
        selected_managed_org_dev_plans_loading: false,
        selected_managed_org_dev_plans_error: false,
        generate_report_error: false,
    },
}); };
function resellerReducer(currentState, action) {
    if (currentState === void 0) { currentState = getInitialState(); }
    return produce(currentState, function (state) {
        var _a, _b, _c, _d;
        switch (action.type) {
            case 'GET_RESELLERS_REQUEST':
                state.resellers_loading = true;
                state.resellers_error = false;
                break;
            case 'GET_RESELLERS_SUCCESS':
                state.resellers_loading = false;
                state.resellers_error = false;
                state.resellers = action.resellers || [];
                break;
            case 'GET_RESELLERS_FAILURE':
                state.resellers_loading = false;
                state.resellers_error = true;
                state.resellers = [];
                break;
            case 'GET_NORMAL_ORGS_REQUEST':
                state.normal_orgs_loading = true;
                state.normal_orgs_error = false;
                break;
            case 'GET_NORMAL_ORGS_SUCCESS':
                state.normal_orgs_loading = false;
                state.normal_orgs_error = false;
                state.normal_orgs_initialized = true;
                state.normal_organizations = action.normal_organizations || [];
                break;
            case 'GET_NORMAL_ORGS_FAILURE':
                state.normal_orgs_loading = false;
                state.normal_orgs_error = true;
                state.normal_organizations = [];
                break;
            case 'ADD_RESELLER_REQUEST':
                state.reseller_add_loading = true;
                state.reseller_add_error = false;
                break;
            case 'ADD_RESELLER_SUCCESS':
                state.reseller_add_loading = false;
                state.reseller_add_error = false;
                state.resellers = action.reseller
                    ? __spreadArray(__spreadArray([], state.resellers, true), [action.reseller], false) : state.resellers;
                break;
            case 'ADD_RESELLER_FAILURE':
                state.reseller_add_loading = false;
                state.reseller_add_error = true;
                break;
            case 'EDIT_RESELLER_SUCCESS':
                state.selected_reseller_details.reseller_details.meta.reseller_number =
                    (_a = action.reseller) === null || _a === void 0 ? void 0 : _a.meta.reseller_number;
                state.resellers = action.reseller
                    ? __spreadArray(__spreadArray([], (_b = state.resellers) === null || _b === void 0 ? void 0 : _b.filter(function (org) { var _a; return org.id !== ((_a = action.reseller) === null || _a === void 0 ? void 0 : _a.id); }), true), [
                        action.reseller,
                    ], false) : state.resellers;
                break;
            case 'REMOVE_RESELLER_REQUEST':
                state.reseller_remove_loading = true;
                state.resellers_remove_error = false;
                break;
            case 'REMOVE_RESELLER_SUCCESS':
                state.reseller_remove_loading = false;
                state.resellers_remove_error = false;
                state.resellers = (_c = state.resellers) === null || _c === void 0 ? void 0 : _c.filter(function (org) { return org.id !== action.org_id; });
                break;
            case 'REMOVE_RESELLER_FAILURE':
                state.reseller_remove_loading = false;
                state.resellers_remove_error = true;
                break;
            case 'GET_RESELLER_DETAILS_REQUEST':
                state.selected_reseller_details.reseller_details_loading = true;
                state.selected_reseller_details.reseller_details_error = false;
                break;
            case 'GET_RESELLERS_DETAILS_SUCCESS':
                state.selected_reseller_details.reseller_details_loading = false;
                state.selected_reseller_details.reseller_details_error = false;
                state.selected_reseller_details.reseller_details =
                    action.reseller_details;
                break;
            case 'GET_RESELLERS_DETAILS_FAILURE':
                state.selected_reseller_details.reseller_details_loading = false;
                state.selected_reseller_details.reseller_details_error = true;
                state.selected_reseller_details.reseller_details = {};
                break;
            case 'GET_INVOICE_SUMMERY_REQUEST':
                state.selected_reseller_details.invoice_summery_loading = true;
                state.selected_reseller_details.invoice_summery_error = false;
                break;
            case 'GET_INVOICE_SUMMERY_SUCCESS':
                state.selected_reseller_details.invoice_summery_loading = false;
                state.selected_reseller_details.invoice_summery_error = false;
                state.selected_reseller_details.invoice_summery =
                    action.invoice_summery;
                break;
            case 'GET_INVOICE_SUMMERY_FAILURE':
                state.selected_reseller_details.invoice_summery_loading = false;
                state.selected_reseller_details.invoice_summery_error = true;
                state.selected_reseller_details.invoice_summery = {};
                break;
            case 'GET_MANAGED_ORGS_REQUEST':
                state.selected_reseller_details.managed_organizations_loading = true;
                state.selected_reseller_details.managed_organizations_error = false;
                break;
            case 'GET_MANAGED_ORGS_SUCCESS':
                state.selected_reseller_details.managed_organizations_loading = false;
                state.selected_reseller_details.managed_organizations_error = false;
                state.selected_reseller_details.managed_organizations =
                    action.managed_organizations || [];
                break;
            case 'GET_MANAGED_ORGS_FAILURE':
                state.selected_reseller_details.managed_organizations_loading = false;
                state.selected_reseller_details.managed_organizations_error = true;
                state.selected_reseller_details.managed_organizations = [];
                break;
            case 'ADD_MANAGED_ORG_REQUEST':
                state.selected_reseller_details.add_managed_organization_loading = true;
                state.selected_reseller_details.add_managed_organization_error = false;
                break;
            case 'ADD_MANAGED_ORG_SUCCESS':
                state.selected_reseller_details.add_managed_organization_loading =
                    false;
                state.selected_reseller_details.add_managed_organization_error = false;
                state.selected_reseller_details.managed_organizations =
                    action.managed_organization
                        ? __spreadArray(__spreadArray([], state.selected_reseller_details.managed_organizations, true), [
                            action.managed_organization,
                        ], false) : state.selected_reseller_details.managed_organizations;
                state.selected_reseller_details.reseller_details.managed_org_count =
                    state.selected_reseller_details.reseller_details.managed_org_count +
                        1;
                break;
            case 'ADD_MANAGED_ORG_FAILURE':
                state.selected_reseller_details.add_managed_organization_loading =
                    false;
                state.selected_reseller_details.add_managed_organization_error = true;
                break;
            case 'REMOVE_MANAGED_ORG_REQUEST':
                state.selected_reseller_details.remove_managed_organization_loading =
                    true;
                state.selected_reseller_details.remove_managed_organization_error =
                    false;
                break;
            case 'REMOVE_MANAGED_ORG_SUCCESS':
                state.selected_reseller_details.remove_managed_organization_loading =
                    false;
                state.selected_reseller_details.remove_managed_organization_error =
                    false;
                state.selected_reseller_details.managed_organizations =
                    (_d = state.selected_reseller_details.managed_organizations) === null || _d === void 0 ? void 0 : _d.filter(function (org) { return org.id !== action.managed_org_id; });
                state.selected_reseller_details.reseller_details.managed_org_count =
                    state.selected_reseller_details.reseller_details.managed_org_count -
                        1;
                break;
            case 'REMOVE_MANAGED_ORG_FAILURE':
                state.selected_reseller_details.remove_managed_organization_loading =
                    false;
                state.selected_reseller_details.remove_managed_organization_error =
                    true;
                break;
            case 'UPDATE_GENERATE_REPORT_ERROR':
                state.selected_reseller_details.generate_report_error = action.error;
                break;
            default:
                break;
        }
    });
}
export default resellerReducer;
